import BaseModelAPI from '../BaseModelAPI';

export default class DoProgressStatus extends BaseModelAPI {
	static entity = 'doprogressstatus';
	static entityName = 'doprogressstatus';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}